import React from 'react';

import TableContext from './table-context';
import { ColumnToggle } from '../column-toggle';

export interface Props {
  tableID: string;
  label: string;
  selectAllLabel?: string;
}

export default class ControlledColumnToggle extends React.Component<Props> {
  render() {
    const { tableID } = this.props;
    return (
      <TableContext.Consumer>
        {({ tables, toggleColumn, toggleColumns }) => {
          const table = tables[tableID];
          const controlledProps = {
            visibleColumns: (table && table.visibleColumns) || {},
            columns: (table && table.columns) || [],
            toggleColumn: toggleColumn && toggleColumn(tableID),
            toggleColumns: toggleColumns && toggleColumns(tableID),
          };
          return <ColumnToggle {...{ ...this.props, ...controlledProps }} />;
        }}
      </TableContext.Consumer>
    );
  }
}
